module.exports = __webpack_public_path__ + "static/media/36.0aee65b7.jpg";